import dayjs from 'dayjs';

const ReminderSettings = class ReminderSettings {
    constructor() {
        this.sendPush = true;
        this.sendEmail = true;
        this.remindAt = dayjs().add(1, 'day');
    }
};

export default ReminderSettings;
